import OrderPadDrawer from './OrderPadDrawer';

export default OrderPadDrawer;
